import { AltriSoggettiNoEsproprioDTO } from "./altri-soggetti-no-esproprio-dto";
import { DatiDepositoNoEsproprioDTO } from "./dati-deposito-no-esproprio-dto";

export class CostituzioneDepositoNoEsproprioDTO {
	altriSoggetti: AltriSoggettiNoEsproprioDTO;
	datiDeposito: DatiDepositoNoEsproprioDTO;
}